import 'babel-polyfill';
import 'isomorphic-fetch';

import HeaderDesktop from './Header/HeaderDesktop';
import HeaderMobile from './Header/HeaderMobile';
//import AppointmentScheduler, { SchedulerInstance } from './AppointmentScheduler/AppointmentScheduler';
import AppointmentScheduler, { SchedulerInstance } from './AppointmentScheduler/AppointmentScheduler';
import ViewLocator, { ViewLocatorInstance } from './ViewLocator/ViewLocator';

import 'bootstrap';

import './Footer/Footer.js'

import './variables.scss';
import './shared.scss';

/* for now using these */
/* need to adjust later */
import './Legacy/site.css';
import './Legacy/style.css';
import './Legacy/responsive.css';

import moment from 'moment';
import Custom from './Legacy/custom';
import { polyfill } from 'smoothscroll-polyfill';

import $ from 'jquery';

import './EmergencyNotification/EmergencyNotification';
import './Accessibility/Accessibility';

polyfill();

new Custom().init();

/* end */

moment.locale('en', {
    weekdaysMin: ["S", "M", "T", "W", "T", "F", "S"]
});

new HeaderDesktop().init();
new HeaderMobile().init();

if (module.hot) {
    module.hot.accept();
}


var elems = document.getElementsByClassName('description');
var readMore = document.getElementsByClassName('std-link-js-click');


Array.prototype.forEach.call(elems, function (item, i) {
    var countOfSymbol = 400;

    if (!readMore[i]) return;

    if (item.innerHTML.length <= countOfSymbol) readMore[i].firstElementChild.classList.add("hidden");
    else {
        item.fullText = item.innerHTML;
        item.innerHTML = item.desc = item.innerHTML.slice(0, countOfSymbol) + "...";
    }


    readMore[i].addEventListener("click", function () {
        if (this.firstElementChild.classList.contains("hidden")) {
            this.previousElementSibling.innerHTML = item.desc;
        } else {
            this.previousElementSibling.innerHTML = item.fullText;
        }


        this.firstElementChild.classList.toggle('hidden');
        this.lastElementChild.classList.toggle('hidden');
    });
})

var button = document.getElementsByClassName("appointment-btn")[0];
var locationButton = document.getElementsByClassName("location-btn")[0];
var buttonMobile = document.getElementsByClassName("appointment-btn-mobile-header")[0];
var scheduler = document.getElementsByClassName("appointment-scheduler")[0];

buttonMobile.addEventListener('click', (e) => {
    e.stopPropagation();
    SchedulerInstance.barToggle();
});

if (locationButton != undefined) {
    locationButton.addEventListener('click', (e) => {
        e.stopPropagation();
        ViewLocatorInstance.barToggle();

    });
}


button.addEventListener('click', (e) => {
    e.stopPropagation();
    SchedulerInstance.barToggle();
});

document.body.addEventListener('click', (e) => {

    if (!scheduler.contains(e.target)) {
        if (ViewLocatorInstance.state.isExpanded) {
            ViewLocatorInstance.barToggle();
        }

        if (SchedulerInstance.state.isExpanded) {
            SchedulerInstance.barToggle();
        }
    }
});



// WEBPACK FOOTER //
// ./Src/Shared/shared.js